export default __webpack_public_path__ + "static/media/close-30px-828282.6e6ed0d2.svg";